import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StudentLmsSidebar from "./components/StudentLmsSidebar";
import StudentLmsTopbar from "./components/StudentLmsTopbar";
import "./lms.css";

export default function StudentLmsLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    setSidebarOpen(false);
  }, []);

  const handleOverlayClick = () => setSidebarOpen(false);

  return (
    <div className="lms-shell">
      {sidebarOpen && (
        <div className="lms-sidebar-overlay" onClick={handleOverlayClick} />
      )}

      <StudentLmsSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="lms-main">
        <StudentLmsTopbar onMenuClick={() => setSidebarOpen((o) => !o)} />

        <main className="lms-content">
          <Outlet />
        </main>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
    </div>
  );
}
